var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.71,28.54C341.23,26.46,415.41,56.1,483,105.19c5.6,4.07,11.21,8.13,16.66,12.39,13.42,10.49,16.17,26.64,6.89,39.76-8.75,12.37-25.44,15.29-39.27,6.62-31.8-19.93-64.34-38.61-100-50.61-93.71-31.51-184.48-22.64-272.3,21.58-16.48,8.3-32.42,17.57-48.15,27.22-16.45,10.09-32.48,7.65-41.86-6.23-9.12-13.49-5.39-29.32,9.52-40.65,52.09-39.6,109-68.86,173.93-80.78A346.06,346.06,0,0,1,259.71,28.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256.27,155.5c54.08-1,101.44,18.4,145.64,47.5,7,4.6,14,9.12,20.71,14.13,12.53,9.42,15,24,6.52,35.76-8.36,11.55-23,13.47-36,5.32Q255.76,172.11,118.2,258c-13.64,8.51-28.3,6.49-36.61-5.6s-5.13-26.75,8.16-36.15c34.53-24.42,70.58-45.78,112.49-55.19C220.06,157.09,238.13,155.72,256.27,155.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.34,276c27.74,0.16,57.33,13.68,83.62,35.35,9.31,7.67,10.83,19.76,4.66,29.64-6,9.58-17.68,13.35-28.78,8.93-8.28-3.3-16.37-7-24.56-10.56-28.93-12.4-57.7-11.28-86.33,1-7.4,3.18-14.66,6.7-22.15,9.67a23.06,23.06,0,0,1-28.59-9.39A22.65,22.65,0,0,1,165.41,311C191.62,289.81,220.85,276.07,262.34,276Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255,483.56c-24.43-.1-44.46-20.35-44.41-44.92a45,45,0,0,1,45.76-45.08c25.14,0.15,44.45,20,44.24,45.56C300.34,464,280.17,483.66,255,483.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalOn);
export default __webpack_public_path__ + "static/media/signal_on.d683bf9e8274a64d764f25d5e4dda4c9.svg";
export { ForwardRef as ReactComponent };